import { useEffect, useState } from "react";
import { toast } from "sonner";
import { adminGet, adminPut } from "@/lib/adminApi";

// Textes légaux & médiation — gérés par Julie en toute autonomie :
// CGU, mentions légales et coordonnées du médiateur de la consommation.
// Laisser un texte vide = la version d'origine (validée) reste affichée.
const FIELDS = [
  { key: "legal_cgu_text", label: "Conditions Générales d'Utilisation (texte complet — laisser vide pour garder la version d'origine)", rows: 10 },
  { key: "legal_mentions_text", label: "Mentions légales (texte complet — laisser vide pour garder la version d'origine)", rows: 10 },
];

const MEDIATION_FIELDS = [
  { key: "mediation_name", label: "Nom de l'organisme de médiation (ex. Médiation de la consommation …)", type: "input" },
  { key: "mediation_contact", label: "Adresse du médiateur (postale ou e-mail)", type: "input" },
  { key: "mediation_website", label: "Site web du médiateur (https://…)", type: "input" },
];

export default function LegalTexts() {
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    adminGet("/admin/legal").then((data) => setForm(data)).catch(() => {});
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await adminPut("/admin/legal", form);
      toast("Textes légaux mis à jour 🤎");
    } catch {
      toast("L'enregistrement a échoué — réessayez.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="rav-admin-panel" data-testid="legal-panel">
      <h3>Textes légaux & médiation</h3>
      <p className="rav-admin-sub">
        Ces contenus s'affichent dans l'application (pages CGU et Mentions légales). Les coordonnées du médiateur de la consommation sont une obligation légale pour la vente en ligne.
      </p>

      <h4 className="rav-admin-h4">Médiation de la consommation</h4>
      {MEDIATION_FIELDS.map((f) => (
        <input
          key={f.key}
          className="rav-input"
          data-testid={`legal-form-${f.key}`}
          placeholder={f.label}
          value={form[f.key] || ""}
          onChange={(e) => setForm({ ...form, [f.key]: e.target.value })}
        />
      ))}

      <h4 className="rav-admin-h4">Conditions générales & mentions légales</h4>
      {FIELDS.map((f) => (
        <textarea
          key={f.key}
          className="rav-input"
          data-testid={`legal-form-${f.key}`}
          placeholder={f.label}
          rows={f.rows}
          value={form[f.key] || ""}
          onChange={(e) => setForm({ ...form, [f.key]: e.target.value })}
        />
      ))}

      <button type="button" className="rav-primary-button" data-testid="legal-form-save" disabled={saving} onClick={save}>
        {saving ? "Enregistrement…" : "Enregistrer les textes"}
      </button>
    </div>
  );
}
